import api from './api';
import type { ApiResponse } from '@/types/api.types';

// Types
export interface StatsData {
  total_files: number;
  total_size_bytes: number;
  total_size_formatted: string;
  success_backups: number;
  failed_backups: number;
  deleted_files: number;
  cloud_status: {
    [provider: string]: string;
  };
  backup_trend: Array<{
    date: string;
    files: number;
    size_gb: number;
  }>;
}

// Mock data
export const statsService = {
  /**
   * Get overview statistics
   */
  async getStats(): Promise<StatsData> {

    const response = await api.get<ApiResponse<StatsData>>('/api/v1/stats');
    return response.data.data!;
  },

};
